import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { formatNOK } from "@/lib/format";
import { sumLinesAmount } from "@/lib/select-convert-tilvalg";
import type { OfferLine } from "@/hooks/use-offers";
import type { OfferSection } from "@/hooks/use-offer-sections";

interface Props {
  sections: OfferSection[];
  lines: OfferLine[];
  selected: Set<string>;
  onToggle: (sectionId: string) => void;
  onConfirm: () => void;
}

/**
 * VIB-1142: For-steg i ConvertOfferDialog. Lar PL huke av hvilke
 * tilvalgsseksjoner kunden valgte før prosjektet opprettes. Uvalgte tilvalg
 * tas ikke med i prosjektet.
 */
export function TilvalgSelectStep({
  sections,
  lines,
  selected,
  onToggle,
  onConfirm,
}: Props) {
  return (
    <div className="flex flex-col gap-4 py-2">
      <div>
        <h3 className="text-sm font-medium">Hvilke tilvalg valgte kunden?</h3>
        <p className="text-xs text-muted-foreground">
          Huk av tilvalgene som skal bli en del av prosjektet. Tilvalg du ikke
          huker av tas ikke med.
        </p>
      </div>
      <div className="space-y-2">
        {sections.map((s) => {
          const sectionLines = lines.filter((l) => l.section_id === s.id);
          const isOn = selected.has(s.id);
          return (
            <label
              key={s.id}
              className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-colors ${
                isOn ? "border-primary bg-primary/5" : "hover:bg-muted/30"
              }`}
            >
              <Checkbox checked={isOn} onCheckedChange={() => onToggle(s.id)} />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium truncate">{s.name}</p>
                <p className="text-xs text-muted-foreground">
                  {sectionLines.length}{" "}
                  {sectionLines.length === 1 ? "linje" : "linjer"}
                </p>
              </div>
              <span className="text-sm font-medium tabular-nums">
                {formatNOK(sumLinesAmount(sectionLines))}
              </span>
            </label>
          );
        })}
      </div>
      <div className="flex justify-end">
        <Button onClick={onConfirm}>
          {selected.size > 0
            ? `Fortsett med ${selected.size} tilvalg`
            : "Fortsett uten tilvalg"}
        </Button>
      </div>
    </div>
  );
}
